import { toast } from "sonner";

// Ações de demonstração — sem backend real nesta etapa.
export function demoAction(label = "Ação") {
  toast(`${label}`, {
    description: "Ação de demonstração — será conectada às APIs reais posteriormente.",
  });
}
